export default from './Survey';



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/SurveyPage/components/Survey/index.js